// source: fix.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
goog.exportSymbol('proto.fix.DatatypeEnum', null, global);
goog.exportSymbol('proto.fix.Decimal32', null, global);
goog.exportSymbol('proto.fix.Decimal64', null, global);
goog.exportSymbol('proto.fix.LocalTimeOnly', null, global);
goog.exportSymbol('proto.fix.LocalTimestamp', null, global);
goog.exportSymbol('proto.fix.Tenor', null, global);
goog.exportSymbol('proto.fix.TimeOnly', null, global);
goog.exportSymbol('proto.fix.Timestamp', null, global);
goog.exportSymbol('proto.fix.VersionEnum', null, global);
goog.exportSymbol('proto.fix.category', null, global);
goog.exportSymbol('proto.fix.enumAdded', null, global);
goog.exportSymbol('proto.fix.enumAddedEp', null, global);
goog.exportSymbol('proto.fix.enumDeprecated', null, global);
goog.exportSymbol('proto.fix.enumValue', null, global);
goog.exportSymbol('proto.fix.fieldAdded', null, global);
goog.exportSymbol('proto.fix.fieldAddedEp', null, global);
goog.exportSymbol('proto.fix.fieldDeprecated', null, global);
goog.exportSymbol('proto.fix.groupTag', null, global);
goog.exportSymbol('proto.fix.msgTypeValue', null, global);
goog.exportSymbol('proto.fix.tag', null, global);
goog.exportSymbol('proto.fix.type', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fix.Tenor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fix.Tenor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fix.Tenor.displayName = 'proto.fix.Tenor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fix.Decimal32 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fix.Decimal32, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fix.Decimal32.displayName = 'proto.fix.Decimal32';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fix.Decimal64 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fix.Decimal64, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fix.Decimal64.displayName = 'proto.fix.Decimal64';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fix.Timestamp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fix.Timestamp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fix.Timestamp.displayName = 'proto.fix.Timestamp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fix.TimeOnly = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fix.TimeOnly, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fix.TimeOnly.displayName = 'proto.fix.TimeOnly';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fix.LocalTimestamp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fix.LocalTimestamp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fix.LocalTimestamp.displayName = 'proto.fix.LocalTimestamp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fix.LocalTimeOnly = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fix.LocalTimeOnly, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fix.LocalTimeOnly.displayName = 'proto.fix.LocalTimeOnly';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fix.Tenor.prototype.toObject = function(opt_includeInstance) {
  return proto.fix.Tenor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fix.Tenor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.Tenor.toObject = function(includeInstance, msg) {
  var f, obj = {
    days: jspb.Message.getFieldWithDefault(msg, 1, 0),
    weeks: jspb.Message.getFieldWithDefault(msg, 2, 0),
    months: jspb.Message.getFieldWithDefault(msg, 3, 0),
    years: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fix.Tenor}
 */
proto.fix.Tenor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fix.Tenor;
  return proto.fix.Tenor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fix.Tenor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fix.Tenor}
 */
proto.fix.Tenor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDays(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setWeeks(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMonths(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setYears(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fix.Tenor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fix.Tenor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fix.Tenor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.Tenor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDays();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getWeeks();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getMonths();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getYears();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional uint32 days = 1;
 * @return {number}
 */
proto.fix.Tenor.prototype.getDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.Tenor} returns this
 */
proto.fix.Tenor.prototype.setDays = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 weeks = 2;
 * @return {number}
 */
proto.fix.Tenor.prototype.getWeeks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.Tenor} returns this
 */
proto.fix.Tenor.prototype.setWeeks = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 months = 3;
 * @return {number}
 */
proto.fix.Tenor.prototype.getMonths = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.Tenor} returns this
 */
proto.fix.Tenor.prototype.setMonths = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 years = 4;
 * @return {number}
 */
proto.fix.Tenor.prototype.getYears = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.Tenor} returns this
 */
proto.fix.Tenor.prototype.setYears = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fix.Decimal32.prototype.toObject = function(opt_includeInstance) {
  return proto.fix.Decimal32.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fix.Decimal32} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.Decimal32.toObject = function(includeInstance, msg) {
  var f, obj = {
    mantissa: jspb.Message.getFieldWithDefault(msg, 1, 0),
    exponent: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fix.Decimal32}
 */
proto.fix.Decimal32.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fix.Decimal32;
  return proto.fix.Decimal32.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fix.Decimal32} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fix.Decimal32}
 */
proto.fix.Decimal32.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setMantissa(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setExponent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fix.Decimal32.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fix.Decimal32.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fix.Decimal32} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.Decimal32.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMantissa();
  if (f !== 0) {
    writer.writeSfixed32(
      1,
      f
    );
  }
  f = message.getExponent();
  if (f !== 0) {
    writer.writeSfixed32(
      2,
      f
    );
  }
};


/**
 * optional sfixed32 mantissa = 1;
 * @return {number}
 */
proto.fix.Decimal32.prototype.getMantissa = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.Decimal32} returns this
 */
proto.fix.Decimal32.prototype.setMantissa = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sfixed32 exponent = 2;
 * @return {number}
 */
proto.fix.Decimal32.prototype.getExponent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.Decimal32} returns this
 */
proto.fix.Decimal32.prototype.setExponent = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fix.Decimal64.prototype.toObject = function(opt_includeInstance) {
  return proto.fix.Decimal64.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fix.Decimal64} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.Decimal64.toObject = function(includeInstance, msg) {
  var f, obj = {
    mantissa: jspb.Message.getFieldWithDefault(msg, 1, 0),
    exponent: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fix.Decimal64}
 */
proto.fix.Decimal64.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fix.Decimal64;
  return proto.fix.Decimal64.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fix.Decimal64} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fix.Decimal64}
 */
proto.fix.Decimal64.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMantissa(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setExponent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fix.Decimal64.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fix.Decimal64.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fix.Decimal64} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.Decimal64.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMantissa();
  if (f !== 0) {
    writer.writeSfixed64(
      1,
      f
    );
  }
  f = message.getExponent();
  if (f !== 0) {
    writer.writeSfixed32(
      2,
      f
    );
  }
};


/**
 * optional sfixed64 mantissa = 1;
 * @return {number}
 */
proto.fix.Decimal64.prototype.getMantissa = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.Decimal64} returns this
 */
proto.fix.Decimal64.prototype.setMantissa = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sfixed32 exponent = 2;
 * @return {number}
 */
proto.fix.Decimal64.prototype.getExponent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.Decimal64} returns this
 */
proto.fix.Decimal64.prototype.setExponent = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fix.Timestamp.prototype.toObject = function(opt_includeInstance) {
  return proto.fix.Timestamp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fix.Timestamp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.Timestamp.toObject = function(includeInstance, msg) {
  var f, obj = {
    seconds: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nanos: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fix.Timestamp}
 */
proto.fix.Timestamp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fix.Timestamp;
  return proto.fix.Timestamp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fix.Timestamp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fix.Timestamp}
 */
proto.fix.Timestamp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSeconds(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNanos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fix.Timestamp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fix.Timestamp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fix.Timestamp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.Timestamp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSeconds();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNanos();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 seconds = 1;
 * @return {number}
 */
proto.fix.Timestamp.prototype.getSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.Timestamp} returns this
 */
proto.fix.Timestamp.prototype.setSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 nanos = 2;
 * @return {number}
 */
proto.fix.Timestamp.prototype.getNanos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.Timestamp} returns this
 */
proto.fix.Timestamp.prototype.setNanos = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fix.TimeOnly.prototype.toObject = function(opt_includeInstance) {
  return proto.fix.TimeOnly.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fix.TimeOnly} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.TimeOnly.toObject = function(includeInstance, msg) {
  var f, obj = {
    seconds: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nanos: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fix.TimeOnly}
 */
proto.fix.TimeOnly.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fix.TimeOnly;
  return proto.fix.TimeOnly.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fix.TimeOnly} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fix.TimeOnly}
 */
proto.fix.TimeOnly.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSeconds(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNanos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fix.TimeOnly.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fix.TimeOnly.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fix.TimeOnly} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.TimeOnly.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSeconds();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNanos();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 seconds = 1;
 * @return {number}
 */
proto.fix.TimeOnly.prototype.getSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.TimeOnly} returns this
 */
proto.fix.TimeOnly.prototype.setSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 nanos = 2;
 * @return {number}
 */
proto.fix.TimeOnly.prototype.getNanos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.TimeOnly} returns this
 */
proto.fix.TimeOnly.prototype.setNanos = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fix.LocalTimestamp.prototype.toObject = function(opt_includeInstance) {
  return proto.fix.LocalTimestamp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fix.LocalTimestamp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.LocalTimestamp.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hours: jspb.Message.getFieldWithDefault(msg, 2, 0),
    minutes: jspb.Message.getFieldWithDefault(msg, 3, 0),
    seconds: jspb.Message.getFieldWithDefault(msg, 4, 0),
    nanos: jspb.Message.getFieldWithDefault(msg, 5, 0),
    hoursoffset: jspb.Message.getFieldWithDefault(msg, 6, 0),
    minutesoffset: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fix.LocalTimestamp}
 */
proto.fix.LocalTimestamp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fix.LocalTimestamp;
  return proto.fix.LocalTimestamp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fix.LocalTimestamp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fix.LocalTimestamp}
 */
proto.fix.LocalTimestamp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHours(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinutes(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeconds(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNanos(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setHoursoffset(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setMinutesoffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fix.LocalTimestamp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fix.LocalTimestamp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fix.LocalTimestamp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.LocalTimestamp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f !== 0) {
    writer.writeSint32(
      1,
      f
    );
  }
  f = message.getHours();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMinutes();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSeconds();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getNanos();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getHoursoffset();
  if (f !== 0) {
    writer.writeSint32(
      6,
      f
    );
  }
  f = message.getMinutesoffset();
  if (f !== 0) {
    writer.writeSint32(
      7,
      f
    );
  }
};


/**
 * optional sint32 date = 1;
 * @return {number}
 */
proto.fix.LocalTimestamp.prototype.getDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimestamp} returns this
 */
proto.fix.LocalTimestamp.prototype.setDate = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 hours = 2;
 * @return {number}
 */
proto.fix.LocalTimestamp.prototype.getHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimestamp} returns this
 */
proto.fix.LocalTimestamp.prototype.setHours = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 minutes = 3;
 * @return {number}
 */
proto.fix.LocalTimestamp.prototype.getMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimestamp} returns this
 */
proto.fix.LocalTimestamp.prototype.setMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 seconds = 4;
 * @return {number}
 */
proto.fix.LocalTimestamp.prototype.getSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimestamp} returns this
 */
proto.fix.LocalTimestamp.prototype.setSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 nanos = 5;
 * @return {number}
 */
proto.fix.LocalTimestamp.prototype.getNanos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimestamp} returns this
 */
proto.fix.LocalTimestamp.prototype.setNanos = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional sint32 hoursOffset = 6;
 * @return {number}
 */
proto.fix.LocalTimestamp.prototype.getHoursoffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimestamp} returns this
 */
proto.fix.LocalTimestamp.prototype.setHoursoffset = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional sint32 minutesOffset = 7;
 * @return {number}
 */
proto.fix.LocalTimestamp.prototype.getMinutesoffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimestamp} returns this
 */
proto.fix.LocalTimestamp.prototype.setMinutesoffset = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fix.LocalTimeOnly.prototype.toObject = function(opt_includeInstance) {
  return proto.fix.LocalTimeOnly.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fix.LocalTimeOnly} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.LocalTimeOnly.toObject = function(includeInstance, msg) {
  var f, obj = {
    hours: jspb.Message.getFieldWithDefault(msg, 1, 0),
    minutes: jspb.Message.getFieldWithDefault(msg, 2, 0),
    seconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    nanos: jspb.Message.getFieldWithDefault(msg, 4, 0),
    hoursoffset: jspb.Message.getFieldWithDefault(msg, 5, 0),
    minutesoffset: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fix.LocalTimeOnly}
 */
proto.fix.LocalTimeOnly.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fix.LocalTimeOnly;
  return proto.fix.LocalTimeOnly.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fix.LocalTimeOnly} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fix.LocalTimeOnly}
 */
proto.fix.LocalTimeOnly.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHours(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinutes(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeconds(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNanos(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setHoursoffset(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setMinutesoffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fix.LocalTimeOnly.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fix.LocalTimeOnly.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fix.LocalTimeOnly} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fix.LocalTimeOnly.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHours();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMinutes();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSeconds();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getNanos();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getHoursoffset();
  if (f !== 0) {
    writer.writeSint32(
      5,
      f
    );
  }
  f = message.getMinutesoffset();
  if (f !== 0) {
    writer.writeSint32(
      6,
      f
    );
  }
};


/**
 * optional int32 hours = 1;
 * @return {number}
 */
proto.fix.LocalTimeOnly.prototype.getHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimeOnly} returns this
 */
proto.fix.LocalTimeOnly.prototype.setHours = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 minutes = 2;
 * @return {number}
 */
proto.fix.LocalTimeOnly.prototype.getMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimeOnly} returns this
 */
proto.fix.LocalTimeOnly.prototype.setMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 seconds = 3;
 * @return {number}
 */
proto.fix.LocalTimeOnly.prototype.getSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimeOnly} returns this
 */
proto.fix.LocalTimeOnly.prototype.setSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 nanos = 4;
 * @return {number}
 */
proto.fix.LocalTimeOnly.prototype.getNanos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimeOnly} returns this
 */
proto.fix.LocalTimeOnly.prototype.setNanos = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional sint32 hoursOffset = 5;
 * @return {number}
 */
proto.fix.LocalTimeOnly.prototype.getHoursoffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimeOnly} returns this
 */
proto.fix.LocalTimeOnly.prototype.setHoursoffset = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional sint32 minutesOffset = 6;
 * @return {number}
 */
proto.fix.LocalTimeOnly.prototype.getMinutesoffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.fix.LocalTimeOnly} returns this
 */
proto.fix.LocalTimeOnly.prototype.setMinutesoffset = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * @enum {number}
 */
proto.fix.VersionEnum = {
  VERSION_UNSPECIFIED: 0,
  VERSION_FIX_2_7: 1,
  VERSION_FIX_3_0: 2,
  VERSION_FIX_4_0: 3,
  VERSION_FIX_4_1: 4,
  VERSION_FIX_4_2: 5,
  VERSION_FIX_4_3: 6,
  VERSION_FIX_4_4: 7,
  VERSION_FIX_5_0: 8,
  VERSION_FIXT_1_1: 9,
  VERSION_FIX_5_0SP1: 10,
  VERSION_FIX_5_0SP2: 11
};

/**
 * @enum {number}
 */
proto.fix.DatatypeEnum = {
  DATATYPE_UNSPECIFIED: 0,
  DATATYPE_CHAR: 1,
  DATATYPE_DATA: 2,
  DATATYPE_FLOAT: 3,
  DATATYPE_INT: 4,
  DATATYPE_DAY_OF_MONTH: 5,
  DATATYPE_MONTH_YEAR: 6,
  DATATYPE_AMT: 7,
  DATATYPE_BOOLEAN: 8,
  DATATYPE_CURRENCY: 9,
  DATATYPE_EXCHANGE: 10,
  DATATYPE_LOCAL_MKT_DATE: 11,
  DATATYPE_MULTIPLE_STRING_VALUE: 12,
  DATATYPE_PRICE: 13,
  DATATYPE_PRICE_OFFSET: 14,
  DATATYPE_QTY: 15,
  DATATYPE_STRING: 16,
  DATATYPE_UTC_TIMESTAMP: 17,
  DATATYPE_UTC_TIME_ONLY: 18,
  DATATYPE_LENGTH: 19,
  DATATYPE_NUM_IN_GROUP: 20,
  DATATYPE_PERCENTAGE: 21,
  DATATYPE_SEQ_NUM: 22,
  DATATYPE_TAG_NUM: 23,
  DATATYPE_COUNTRY: 24,
  DATATYPE_MULTIPLE_CHAR_VALUE: 25,
  DATATYPE_PATTERN: 26,
  DATATYPE_RESERVED1000PLUS: 27,
  DATATYPE_RESERVED100PLUS: 28,
  DATATYPE_RESERVED4000PLUS: 29,
  DATATYPE_TENOR: 30,
  DATATYPE_TZ_TIMESTAMP: 31,
  DATATYPE_TZ_TIME_ONLY: 32,
  DATATYPE_UTC_DATE_ONLY: 33,
  DATATYPE_XML_DATA: 34,
  DATATYPE_LANGUAGE: 35
};


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `category`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.fix.category = new jspb.ExtensionFieldInfo(
    63002,
    {category: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FileOptions.extensionsBinary[63002] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.category,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FileOptions.extensions[63002] = proto.fix.category;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `msgTypeValue`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.fix.msgTypeValue = new jspb.ExtensionFieldInfo(
    65001,
    {msgTypeValue: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MessageOptions.extensionsBinary[65001] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.msgTypeValue,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MessageOptions.extensions[65001] = proto.fix.msgTypeValue;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `tag`.
 * @type {!jspb.ExtensionFieldInfo<number>}
 */
proto.fix.tag = new jspb.ExtensionFieldInfo(
    66003,
    {tag: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[66003] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.tag,
    jspb.BinaryReader.prototype.readFixed32,
    jspb.BinaryWriter.prototype.writeFixed32,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[66003] = proto.fix.tag;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `type`.
 * @type {!jspb.ExtensionFieldInfo<!proto.fix.DatatypeEnum>}
 */
proto.fix.type = new jspb.ExtensionFieldInfo(
    66004,
    {type: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[66004] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.type,
    jspb.BinaryReader.prototype.readEnum,
    jspb.BinaryWriter.prototype.writeEnum,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[66004] = proto.fix.type;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `fieldAdded`.
 * @type {!jspb.ExtensionFieldInfo<!proto.fix.VersionEnum>}
 */
proto.fix.fieldAdded = new jspb.ExtensionFieldInfo(
    66005,
    {fieldAdded: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[66005] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.fieldAdded,
    jspb.BinaryReader.prototype.readEnum,
    jspb.BinaryWriter.prototype.writeEnum,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[66005] = proto.fix.fieldAdded;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `fieldAddedEp`.
 * @type {!jspb.ExtensionFieldInfo<number>}
 */
proto.fix.fieldAddedEp = new jspb.ExtensionFieldInfo(
    66006,
    {fieldAddedEp: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[66006] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.fieldAddedEp,
    jspb.BinaryReader.prototype.readSfixed32,
    jspb.BinaryWriter.prototype.writeSfixed32,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[66006] = proto.fix.fieldAddedEp;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `fieldDeprecated`.
 * @type {!jspb.ExtensionFieldInfo<!proto.fix.VersionEnum>}
 */
proto.fix.fieldDeprecated = new jspb.ExtensionFieldInfo(
    66007,
    {fieldDeprecated: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[66007] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.fieldDeprecated,
    jspb.BinaryReader.prototype.readEnum,
    jspb.BinaryWriter.prototype.writeEnum,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[66007] = proto.fix.fieldDeprecated;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `groupTag`.
 * @type {!jspb.ExtensionFieldInfo<number>}
 */
proto.fix.groupTag = new jspb.ExtensionFieldInfo(
    66008,
    {groupTag: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[66008] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.groupTag,
    jspb.BinaryReader.prototype.readFixed32,
    jspb.BinaryWriter.prototype.writeFixed32,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[66008] = proto.fix.groupTag;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `enumValue`.
 * @type {!jspb.ExtensionFieldInfo<string>}
 */
proto.fix.enumValue = new jspb.ExtensionFieldInfo(
    72004,
    {enumValue: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.EnumValueOptions.extensionsBinary[72004] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.enumValue,
    jspb.BinaryReader.prototype.readString,
    jspb.BinaryWriter.prototype.writeString,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.EnumValueOptions.extensions[72004] = proto.fix.enumValue;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `enumAdded`.
 * @type {!jspb.ExtensionFieldInfo<!proto.fix.VersionEnum>}
 */
proto.fix.enumAdded = new jspb.ExtensionFieldInfo(
    72005,
    {enumAdded: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.EnumValueOptions.extensionsBinary[72005] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.enumAdded,
    jspb.BinaryReader.prototype.readEnum,
    jspb.BinaryWriter.prototype.writeEnum,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.EnumValueOptions.extensions[72005] = proto.fix.enumAdded;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `enumAddedEp`.
 * @type {!jspb.ExtensionFieldInfo<number>}
 */
proto.fix.enumAddedEp = new jspb.ExtensionFieldInfo(
    72006,
    {enumAddedEp: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.EnumValueOptions.extensionsBinary[72006] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.enumAddedEp,
    jspb.BinaryReader.prototype.readSfixed32,
    jspb.BinaryWriter.prototype.writeSfixed32,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.EnumValueOptions.extensions[72006] = proto.fix.enumAddedEp;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `enumDeprecated`.
 * @type {!jspb.ExtensionFieldInfo<!proto.fix.VersionEnum>}
 */
proto.fix.enumDeprecated = new jspb.ExtensionFieldInfo(
    72007,
    {enumDeprecated: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.EnumValueOptions.extensionsBinary[72007] = new jspb.ExtensionFieldBinaryInfo(
    proto.fix.enumDeprecated,
    jspb.BinaryReader.prototype.readEnum,
    jspb.BinaryWriter.prototype.writeEnum,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.EnumValueOptions.extensions[72007] = proto.fix.enumDeprecated;

goog.object.extend(exports, proto.fix);
